<template>
  <div>
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户联系人</el-breadcrumb-item>
    </el-breadcrumb> -->
    <div class="panel mt-20" v-if="!isLastList">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
          @submit.native.prevent
        >
          <el-form-item
            label="关键字"
            prop="query"
            v-if="isMobile() && !filterShow"
          >
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="电号、姓名、公司名"
              clearable
              @keyup.enter.native="reqeustCustomerUsers"
            ></el-input>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item
              label="关键字"
              prop="query"
              v-if="filterShow || !isMobile()"
            >
              <el-input
                size="small"
                v-model="filter.query"
                autocomplete="off"
                clearable
                placeholder="电号、姓名、公司名"
                @keyup.enter.native="reqeustCustomerUsers"
              ></el-input>
            </el-form-item>
            <el-form-item label="渠道来源">
              <QrcodeSelect v-model="filter.qrcode_id"></QrcodeSelect>
            </el-form-item>
            <el-form-item label="状态" v-if="!status">
              <el-select
                v-model="filter.status"
                size="small"
                placeholder="请选择"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="(value, index) in CustomerUserStatusMap"
                  :key="index"
                  :label="value"
                  :value="parseInt(index)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型" v-if="!status">
              <el-select
                v-model="filter.customer_category"
                size="small"
                placeholder="请选择"
                style="width: 100%"
                :clearable="true"
              >
                <el-option
                  v-for="(value, index) in CustomerCategroyMap"
                  :key="index"
                  :label="value"
                  :value="parseInt(index)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注册时间" v-if="!status">
              <el-date-picker
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                reqeustCustomerUsers()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div :class="isLastList ? '' : 'panel mt-20'">
      <file-button
        style="float: right"
        class="mobile-hide"
        obj="customer_user"
        :filter="filter"
        :importButton="false"
      ></file-button>

      <el-table
        v-if="!isMobile()"
        ref="customerDeviceTable"
        :data="users"
        stripe
        style="width: 100%"
      >
        <el-table-column label="电话/姓名" align="left" prop="name">
          <template slot-scope="scope">
            {{ scope.row.mobile
            }}{{ scope.row.name ? `（${scope.row.name}）` : '' }}
            <el-tag size="mini" v-if="scope.row.bind_type">关联通过</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="电话"
          align="left"
          prop="mobile"
        ></el-table-column> -->
        <el-table-column
          label="公司名称"
          align="left"
          prop="company_name"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-tag size="mini" class="mr-5">
              {{ DealerCategories[scope.row.customer.category] }}</el-tag
            >
            <template v-if="scope.row.dealer_id > 0">
              <customer-link
                class="font-12"
                :customer="scope.row.dealer"
              ></customer-link>
            </template>
            <template v-else-if="scope.row.customer_id > 0">
              <customer-link :customer="scope.row.customer"></customer-link>
            </template>
            <template v-else>
              {{ scope.row.company_name + '（申请名）' }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" align="center">
          <template slot-scope="scope">
            {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
          </template>
        </el-table-column>
        <el-table-column label="渠道来源" align="center">
          <template slot-scope="scope">
            {{ scope.row.qrcode.name || '自主注册' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" v-if="!isLastList">
          <template slot-scope="scope">
            <div>{{ CustomerUserStatusMap[scope.row.status] }}</div>
            <el-tag
              type="danger"
              size="mini"
              v-if="
                scope.row.status == 1 && scope.row.service_quests.length > 0
              "
              >有新服务请求</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="right"
          width="200"
          v-if="!isLastList"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 1"
              @click="rejectUser(scope.row, scope.$index)"
              size="mini"
              type="danger"
              plain
              >拒绝</el-button
            >
            <el-button
              class="ml-5"
              type="primary"
              size="mini"
              plain
              @click="bindCustomer(scope.row, scope.$index)"
              >{{ scope.row.status == 1 ? '启用' : '编辑' }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li
          v-for="(item, index) in users"
          style="align-items: start"
          :key="item.id"
        >
          <div>
            <div
              class="flex-row-between"
              style="height: 20px; line-height: 20px; margin-bottom: 10px"
            >
              <div
                class="flex-row"
                style="line-height: 1.5; align-items: center"
              >
                <span> 姓名：{{ item.name }} </span>
                <el-tag class="ml-5" size="mini" v-if="item.bind_type"
                  >关联通过</el-tag
                >
              </div>
              <div v-if="!isLastList">
                <el-button
                  @click="rejectUser(item, index)"
                  v-if="item.status == 1"
                  size="mini"
                  type="danger"
                  plain
                  >拒绝</el-button
                >
                <el-button
                  type="primary"
                  class="text-primary ml-5"
                  size="mini"
                  plain
                  v-if="item.status == 1"
                  @click="bindCustomer(item, index)"
                  >启用</el-button
                >
              </div>
            </div>
            <div class="font-12">
              <span>电话号码：</span>
              {{ item.mobile }}
            </div>
            <div class="font-12">
              <span>申请时间：</span>
              {{ $time(item.created_at).format('YYYY-MM-DD HH:mm') }}
            </div>
            <div class="font-12" v-if="!isLastList">
              <span>状态：</span>
              {{ CustomerUserStatusMap[item.status] }}
              <el-tag
                type="danger"
                size="mini"
                v-if="item.status == 1 && item.service_quests.length > 0"
                >有新服务请求</el-tag
              >
            </div>
            <div class="text-info-12">
              公司：
              <el-tag size="mini" class="mr-5" v-if="item.dealer_id > 0">
                {{ DealerCategories[item.dealer.category_id] }}</el-tag
              >
              <customer-link
                v-if="item.dealer_id > 0"
                class="font-12"
                :customer="item.dealer"
              ></customer-link>
              <customer-link
                :customer="item.customer"
                v-else-if="item.customer_id > 0"
              ></customer-link>
              <template v-else>{{ item.company_name }}（申请名）</template>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="users.length == 0 && isMobile()" class="text-info-12">
        暂无数据。
      </div>
      <div class="table-option" v-if="!isLastList">
        <el-pagination
          :page-size="filter.size"
          :current-page.sync="filter.page"
          layout="total, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <item-former
      :model="model"
      :show.sync="itemFormerVisible"
      @updated="updatedCallback"
    ></item-former>
  </div>
</template>

<script>
import { customerUserList, updateCustomerUser } from '../../service/getData'
import { isMobile, scrollToTop } from '@/util/index'
import ItemFormer from './former'
import { clone } from '../../util'
import { DealerCategories, CustomerCategroyMap } from '@/config/global.js'
import QrcodeSelect from './QrcodeSelect.vue'
import store from '@/store/store'

export default {
  props: {
    status: {
      type: Number,
      default: 0,
    },
    isLastList: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ItemFormer,
    QrcodeSelect,
  },
  data() {
    return {
      userInfo: store.getters.userInfo,
      CustomerCategroyMap,
      model: {},
      DealerCategories,
      itemFormerVisible: false,
      editIndex: 0,
      filter: {
        query: '',
        status: this.status,
        qrcode_id: '',
        customer_category: '',
        date: '',
        size: this.isLastList ? 10 : 20,
        page: 1,
      },
      isMobile,
      scrollToTop,
      total: 0,
      users: [],
      filterShow: false,
      loading: false,
      CustomerUserStatusMap: {
        0: '不限',
        1: '待审核',
        2: '正常',
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.reqeustCustomerUsers()
    },
  },
  created() {
    // let status = parseInt(this.$route.query.status || -1)
    // status = status < 0 ? null : status

    this.filter = {
      page: parseInt(this.$route.query.page || 1),
      size: parseInt(this.$route.query.size || this.filter.size),
      query: this.$route.query.query || '',
      qrcode_id: parseInt(this.$route.query.qrcode_id || 0),
      status: parseInt(this.$route.query.status || this.status),
      date: this.$route.query.date || [],
      customer_category: this.$route.query.customer_category
        ? parseInt(this.$route.query.customer_category)
        : '',
    }
    this.reqeustCustomerUsers()
  },
  methods: {
    bindCustomer(item, index) {
      this.model = clone(item)
      this.model.status = 2
      this.editIndex = index
      this.itemFormerVisible = true
    },
    async rejectUser(item, index) {
      this.$prompt('请填写拒绝原因', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '拒绝原因不能为空',
      })
        .then(async ({ value }) => {
          let res = await updateCustomerUser({
            id: item.id,
            status: 0,
            remark: value,
          })
          if (res.code == 0) {
            this.users.splice(index, 1)
            this.$emit('updateGoingCount')
          }
        })
        .catch(() => {})
    },
    updatedCallback(data) {
      this.$set(this.users, this.editIndex, data)
      this.$emit('updateGoingCount')
    },
    async reqeustCustomerUsers() {
      let data = {
        size: this.filter.size,
        page: this.filter.page - 1,
        qrcode_id: this.filter.qrcode_id,
        customer_category: this.filter.customer_category,
        query: this.filter.query,
        status: this.filter.status,
        date: this.filter.date,
      }

      this.$router.replace({
        query: this.filter,
      })

      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      this.loading = true
      let res = await customerUserList(data)
      if (res.code == 0) {
        this.users = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    reset() {
      this.filter.date = ''
      this.filter.query = ''
      this.filter.page = 1
      this.filter.qrcode_id = ''
      this.filter.customer_category = ''
      this.filter.status = this.status
      this.reqeustCustomerUsers()
    },
  },
}
</script>

<style scoped>
/deep/ .el-checkbox__label {
  font-size: 12px !important;
}
.cc {
  padding: 1px 3px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 12px;
  word-break: keep-all;
  /* margin-left: 4px; */
}
.table-option {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  flex-wrap: wrap;
}
</style>
